
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'bs-dropdown-tooltip',
    props: {
        position: {
            type: String as PropType<'absolute' | 'fixed'>,
            default: 'absolute'
        },
        x: {
            type: Number,
            default: null,
        },
        y: {
            type: Number,
            default: null
        },
        maxHeight: {
            type: String,
            default: '300px'
        }
    },
})
